import { render, staticRenderFns } from "./printinvoice.vue?vue&type=template&id=55222ba1&scoped=true&"
import script from "./printinvoice.vue?vue&type=script&lang=js&"
export * from "./printinvoice.vue?vue&type=script&lang=js&"
import style0 from "./printinvoice.vue?vue&type=style&index=0&id=55222ba1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55222ba1",
  null
  
)

export default component.exports